"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user");
var _permission = require("@/utils/permission");
var _debounce = _interopRequireDefault(require("@/libs/debounce"));
var _benefitsCreat = _interopRequireDefault(require("../components/benefitsCreat..vue"));
var _explainCreat = _interopRequireDefault(require("../components/explainCreat.vue"));
var _cardCreat = _interopRequireDefault(require("../components/cardCreat.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var cardInfo = {
  deadlineDay: 0,
  giftBalance: 0,
  id: 0,
  isFirstChargeGive: false,
  label: '',
  name: '',
  originalPrice: 0,
  price: 0,
  sort: 0,
  status: true,
  type: 0
};
var _default = exports.default = {
  name: 'Configure',
  components: {
    CardCreat: _cardCreat.default,
    ExplainCreat: _explainCreat.default,
    BenefitsEdit: _benefitsCreat.default
  },
  data: function data() {
    return {
      activeName: 'first',
      pram: {
        paidMemberPaidEntrance: 1,
        paidMemberPriceDisplay: 'all',
        paidMemberProductSwitch: 1
      },
      listLoading: false,
      tableData: [],
      //会员权益列表
      drawerVisible: false,
      //权益
      pramInfo: null,
      drawerVisibleExplain: false,
      //权益说明
      tableDataMember: [],
      //会员卡列表
      drawerVisibleCard: false //会员卡
    };
  },
  watch: {
    activeName: {
      handler: function handler(val) {
        if (val === 'second') this.getList();
        if (val === 'three') this.getMemberList();
      },
      deep: true,
      immediate: false
    }
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:paid:member:base:config:get'])) this.getMemberConfig();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    //基础设置
    memberConfigSubmitForm: function memberConfigSubmitForm(formName) {
      var _this = this;
      (0, _user.memberConfigEditApi)(this.pram).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                _this.$message.success('提交成功');
                _this.getMemberConfig();
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    getMemberConfig: function () {
      var _getMemberConfig = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return (0, _user.memberConfigGetApi)();
            case 1:
              this.pram = _context2.v;
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t = _context2.v;
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getMemberConfig() {
        return _getMemberConfig.apply(this, arguments);
      }
      return getMemberConfig;
    }(),
    //会员卡列表
    getMemberList: function () {
      var _getMemberList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.listLoading = true;
              _context3.p = 1;
              _context3.n = 2;
              return (0, _user.memberCardListApi)();
            case 2:
              this.tableDataMember = _context3.v;
              this.listLoading = false;
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t2 = _context3.v;
              this.listLoading = false;
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 3]]);
      }));
      function getMemberList() {
        return _getMemberList.apply(this, arguments);
      }
      return getMemberList;
    }(),
    //行删除
    handleDelete: function handleDelete(index, row) {
      var _this2 = this;
      this.$modalSure('要删除此会员卡吗？').then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return (0, _user.memberCardDeleteApi)(row.id);
            case 1:
              _this2.$message.success('删除成功');
              _this2.tableDataMember.splice(index, 1);
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t3 = _context4.v;
            case 3:
              return _context4.a(2);
          }
        }, _callee4, null, [[0, 2]]);
      })));
    },
    //会员卡关闭
    onClosedrawerVisibleCard: function onClosedrawerVisibleCard() {
      this.drawerVisibleCard = false;
    },
    //会员卡创建
    handlerCreat: function handlerCreat(row) {
      this.pramInfo = row ? row : Object.assign({}, cardInfo);
      this.drawerVisibleCard = true;
    },
    //会员卡创建成功
    subSuccessCard: function subSuccessCard() {
      this.getMemberList();
      this.onClosedrawerVisibleCard();
    },
    //会员权益列表
    getList: function () {
      var _getList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              this.listLoading = true;
              _context5.p = 1;
              _context5.n = 2;
              return (0, _user.memberBenefitsListApi)();
            case 2:
              this.tableData = _context5.v;
              this.listLoading = false;
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t4 = _context5.v;
              this.listLoading = false;
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this, [[1, 3]]);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    //会员权益修改状态
    handleStatusChange: (0, _debounce.default)(/*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(row, name) {
        var _t5;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              if (!(name === 'benefits')) {
                _context6.n = 2;
                break;
              }
              _context6.n = 1;
              return (0, _user.memberBenefitsStatementSwitchApi)(row.id);
            case 1:
              this.getList();
              _context6.n = 4;
              break;
            case 2:
              _context6.n = 3;
              return (0, _user.memberCardSwitchApi)(row.id);
            case 3:
              this.getMemberList();
            case 4:
              this.$message.success('更新状态成功');
              _context6.n = 6;
              break;
            case 5:
              _context6.p = 5;
              _t5 = _context6.v;
              row.status = !row.status;
            case 6:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 5]]);
      }));
      return function (_x2, _x3) {
        return _ref3.apply(this, arguments);
      };
    }()),
    //会员权益设置
    handleCreatBenefits: function handleCreatBenefits(row) {
      this.pramInfo = row;
      this.drawerVisible = true;
    },
    //会员权益关闭弹窗
    onClosedrawerVisible: function onClosedrawerVisible() {
      this.drawerVisible = false;
    },
    subSuccessBenefits: function subSuccessBenefits() {
      this.getList();
      this.onClosedrawerVisible();
    },
    //权益说明
    handleCreatExplain: function handleCreatExplain(row) {
      this.pramInfo = row;
      this.drawerVisibleExplain = true;
    },
    //权益说明关闭
    onClosedrawerVisibleExplain: function onClosedrawerVisibleExplain() {
      this.drawerVisibleExplain = false;
    },
    subSuccessExplain: function subSuccessExplain() {
      this.getList();
      this.onClosedrawerVisibleExplain();
    }
  }
};